import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import richTextOptions from './richTextOptions';

function renderHtml(data) {
  return documentToHtmlString(data, richTextOptions);
}

export default renderHtml;
